<template>
  <zt-modal
    class="rounded font-normal"
    :title="$t('message.abm.folders.modals.cancelSubFolder.title')"
    @close="activeModalConfirmDiscard(false)" max-width="600px"
    :active="active"
    :z-index="1001"
  >
    <template>
      <div class="flex px-10 py-12">
        <div class="flex flex-none items-center w-24 h-24 justify-center mr-16">
          <zt-icon
            name="exclamation-circle-outline"
            class="text-zt-warning"
            :style="{ fontSize: '6rem'}"
          />
        </div>
        <div>
          <p class="text-zt-xl mb-4 text-zt-dark-500">
            {{ $t('message.abm.folders.modals.cancelSubFolderConfig.cancelQuestion') }}
          </p>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div
        class="zt-modal-footer rounded-b flex justify-end items-center p-4"
      >
        <zt-button
          text
          color="dark-300"
          class="button-cancel mr-4"
          @click="discard"
          data-vs-button="dismiss"
        >
          {{ $t('message.abm.folders.modals.cancelSubFolderConfig.dismiss') }}
        </zt-button>
        <zt-button
          class="w-25"
          @click="apply"
          data-vs-button="apply"
        >
          {{ $t('message.abm.folders.modals.cancelSubFolderConfig.ok') }}
        </zt-button>
      </div>
    </template>
  </zt-modal>
</template>
<script>
export default {
  name: 'CancelSignatureConfigDialog',
  inject: [
    'activeModal',
    'activeModalConfirmDiscard',
    'modalState'
  ],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    folderName: {
      type: String,
      default: ''
    },
    withSubFolder: {
      type: Boolean,
      default: false
    },
    isLeave: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async discard() {
      this.activeModalConfirmDiscard(false)
      this.activeModal()
    },
    async apply() {
      this.$emit('handlerClick')
      this.activeModalConfirmDiscard(false)
      this.activeModal(false)
    }
  }
}
</script>

<style scoped lang="scss">
.zt-modal-footer {
  background-color: #EEEEEE;
}
.text-custom-legend {
  font-size: 1.125rem;
}
::v-deep {
  .zt-modal {
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
    0 1px 8px rgba(0, 0, 0, 0.2);
  }
  .zt-modal.rounded {
    border-radius: .375rem!important;
  }
  button.button-cancel {
    color: #707070!important;
    background-color: transparent!important;
  }
}
</style>